module.exports = __webpack_public_path__ + "media/images/games/k2reveal/crane-52676f45d2d074c29c970ff7494525af.png";